<template>
  <div class="sf-el notice-item">
    <div class="sf-notice" :class="`sf-notice--${variant}`">
      <div class="sf-notice__content" v-html="resolvedContent"></div>
    </div>
  </div>
</template>

<script>
  import { toRef } from 'vue';
  import { useDynamicContent } from '@shared/composables/useDynamicContent';

  export default {
    name: 'NoticeElement',
    props: {
      content: {
        type: String,
        default: '',
      },
      variant: {
        type: String,
        default: 'info',
        validator: (v) => ['info', 'warning', 'success', 'error', 'brand'].includes(v),
      },
      parameters: {
        type: Array,
        default: () => [],
      },
    },
    setup(props) {
      const resolvedContent = useDynamicContent(toRef(props, 'content'), props.parameters);

      return {
        resolvedContent,
      };
    },
  };
</script>

<style scoped lang="scss">
  .sf-notice {
    display: flex;
    gap: 0.75rem;
    padding: 1rem 1.125rem;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    line-height: 1.6;

    &--info {
      background-color: var(--cs-notice-info-bg, #eff6ff);
      color: var(--cs-notice-info-text, #1e40af);
      border: 1px solid var(--cs-notice-info-border, #bfdbfe);
    }

    &--warning {
      background-color: var(--cs-notice-warning-bg, #fffbeb);
      color: var(--cs-notice-warning-text, #92400e);
      border: 1px solid var(--cs-notice-warning-border, #fde68a);
    }

    &--success {
      background-color: var(--cs-notice-success-bg, #f0fdf4);
      color: var(--cs-notice-success-text, #166534);
      border: 1px solid var(--cs-notice-success-border, #bbf7d0);
    }

    &--error {
      background-color: var(--cs-notice-error-bg, #fef2f2);
      color: var(--cs-notice-error-text, #991b1b);
      border: 1px solid var(--cs-notice-error-border, #fecaca);
    }

    &--brand {
      background-color: var(--cs-brand-primary-light, #f0f4ff);
      color: var(--cs-text-body, #374151);
      border: 1px solid var(--cs-brand-primary, #3b82f6);
    }

    &__icon {
      flex-shrink: 0;
      display: flex;
      align-items: flex-start;
      padding-top: 0.1rem;
    }

    &__content {
      flex: 1;

      :deep(h1),
      :deep(h2),
      :deep(h3),
      :deep(h4) {
        margin: 0 0 0.25rem 0;
        font-weight: 600;
        color: inherit;
        line-height: 1.3;
      }

      :deep(h3) {
        font-size: 1rem;
      }

      :deep(p) {
        margin: 0 0 0.25rem 0;
        color: inherit;
        &:not(:last-child) {
          margin-bottom: 0.25rem;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }

      :deep(ul),
      :deep(ol) {
        margin: 0.25rem 0;
        padding-left: 1.25rem;
        color: inherit;
      }

      :deep(li) {
        margin-bottom: 0.125rem;
      }

      :deep(strong) {
        font-weight: 600;
      }
    }
  }
</style>
